import { Navigate, useRoutes } from 'react-router-dom';

import { baseRoutes } from './base';
import { publicRoutes } from './public';
import { privateRoutes } from './private';

// ----------------------------------------------------------------------

export default function Router() {
  return useRoutes([
    // Public routes
    ...publicRoutes,

    // Private routes
    ...privateRoutes,

    // Base routes
    ...baseRoutes,

    // No match 404
    {
      path: '*',
      element: (
        <Navigate
          to="/404"
          replace
        />
      ),
    },
  ]);
}
